import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export type BookingParams = 'seekerId' | 'subject' | 'requestTutorLevel';
type SearchParams =
  | 'city'
  | 'cityId'
  | 'page'
  | 'sortBy'
  | 'subject'
  | 'token'
  | 'requestTeachingLevel';
export type UpcomingLessonParams = 'showLesson' | 'anyStudent';

class URLSearchParamsTyped extends URLSearchParams {
  // override get() to prevent typos
  get<T extends string | null>(name: SearchParams | BookingParams | UpcomingLessonParams) {
    return super.get(name) as T;
  }
}

export function useSearchParams() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParamsTyped(search), [search]);
}
